module.exports = __webpack_public_path__ + "overlook-studios/img/project-synthecite2.png";